export function getWindowParams(params) {
  return Object.keys(params).map(function (key) {
    if (typeof params[key] === 'boolean') {
      return key;
    } else {
      return "".concat(key, "=").concat(params[key]);
    }
  }).join(',');
}
export function checkPushAllowed() {
  if (!ServiceWorkerRegistration) {
    console.warn('Push worker is not registered');
    return false;
  }
  if (!('showNotification' in ServiceWorkerRegistration.prototype)) {
    console.warn("Notifications aren't supported.");
    return false;
  }
  if (Notification.permission === 'denied') {
    console.warn('The user has blocked notifications.');
    return false;
  }
  if (!('PushManager' in window)) {
    console.warn("Push messaging isn't supported.");
    return false;
  }
  return true;
}